import { CountryCodes } from "./amazonAds"

export interface INewProject {
  countryCode: CountryCodes
  title: string
  asins: string[]
  primaryAsin?: string
  keywords: string[]
  projectId?: string
  campaignIds: string[]
}

export enum ProjectTabKeys {
  ASINS = "asins",
  KEYWORDS = "keywords",
  SQP = "sqp",
  RANKS = "ranks",
  TRENDS = "trends",
}

export enum AmazonDataState {
  "NEW" = "NEW",
  "AVAILABLE" = "AVAILABLE",
  "NOT_IN_AMAZON" = "NOT_IN_AMAZON",
}
